module.exports = {
  provider_name: '疾管署',
  app_name: '疾管家',
  vsafe_name: 'Taiwan V-Watch',
  taiwanCounties: {
    新北市: ['新北市', 'New Taipei City'],
    臺北市: ['臺北市', '台北市', 'Taipei City'],
    基隆市: ['基隆市', 'Keelung City'],
    宜蘭縣: ['宜蘭縣', 'Yilan County'],
    桃園市: ['桃園市', 'Taoyuan City'],
    新竹市: ['新竹市', 'Hsinchu City'],
    新竹縣: ['新竹縣', 'Hsinchu County'],
    苗栗縣: ['苗栗縣', 'Miaoli County'],
    臺中市: ['臺中市', '台中市', 'Taichung City'],
    彰化縣: ['彰化縣', 'Changhua County'],
    南投縣: ['南投縣', 'Nantou County'],
    雲林縣: ['雲林縣', 'Yunlin County'],
    嘉義市: ['嘉義市', 'Chiayi City'],
    嘉義縣: ['嘉義縣', 'Chiayi County'],
    臺南市: ['臺南市', '台南市', 'Tainan City'],
    高雄市: ['高雄市', 'Kaohsiung City'],
    屏東縣: ['屏東縣', 'Pingtung County'],
    花蓮縣: ['花蓮縣', 'Hualien County'],
    臺東縣: ['臺東縣', '台東縣', 'Taitung County'],
    金門縣: ['金門縣', 'Kinmen County'],
    連江縣: ['連江縣', 'Lienchiang County'],
    澎湖縣: ['澎湖縣', 'Penghu County'],
  },
  taiwanAreas: {
    '臺北、新北、基隆、宜蘭': ['新北市', '臺北市', '台北市', '基隆市', '宜蘭縣'],
    '桃園、新竹、苗栗': ['桃園市', '新竹市', '新竹縣', '苗栗縣'],
    '臺中、彰化、南投': ['臺中市', '台中市', '彰化縣', '南投縣'],
    '雲林、嘉義、臺南': ['雲林縣', '嘉義市', '嘉義縣', '臺南市', '台南市'],
    '高雄、屏東': ['高雄市', '屏東縣'],
    '花蓮、臺東': ['花蓮縣', '臺東縣', '台東縣'],
    '金門、連江、澎湖': ['金門縣', '連江縣', '澎湖縣'],
  },
  commonDiseases: {
    '19nCoV': {
      name: '19nCoV',
      label: 'COVID-19',
    },
    INFLUENZA: {
      name: 'INFLUENZA',
      label: '流感',
    },
    ENTEROVIRUS: {
      name: 'ENTEROVIRUS',
      label: '腸病毒',
    },
    DENGUEFEVER: {
      name: 'DENGUEFEVER',
      label: '登革熱',
    },
    TBC: {
      name: 'TBC',
      label: '結核病',
    },
    MEASLES: {
      name: 'MEASLES',
      label: '麻疹',
    },
    RUBELLA: {
      name: 'RUBELLA',
      label: '德國麻疹',
    },
    ENTEROGASTRITIS: {
      name: 'ENTEROGASTRITIS',
      label: '病毒性腸胃炎',
    },
    JE: {
      name: 'JE',
      label: '日本腦炎',
    },
    INFLUENZAA: {
      name: 'INFLUENZAA',
      label: '新型A型流感',
    },
    // backup items below
    VARICELLA: {
      name: 'VARICELLA',
      label: '水痘併發症',
    },
    AIDS: {
      name: 'AIDS',
      label: '愛滋病',
    },
    SCRUBTYPHUS: {
      name: 'SCRUBTYPHUS',
      label: '恙蟲病',
    },
    ZIKA: {
      name: 'ZIKA',
      label: '茲卡病毒',
    },
    PREGNANT: {
      name: 'PREGNANT',
      label: '孕婦常見傳染病',
      subject: '孕婦',
      disease: '常見傳染病',
    },
    BABY: {
      name: 'BABY',
      label: '嬰幼兒常見傳染病',
      subject: '嬰幼兒',
      disease: '常見傳染病',
    },
    TRAVEL: {
      name: 'TRAVEL',
      label: '旅遊高風險傳染病',
      subject: '旅途中',
      disease: '傳染病',
    },
  },
  pregnantVaccine: {
    name: {
      TDAP: '(自費)減量破傷風白喉非細胞性百日咳混合疫苗(Tdap)',
      INFLUENZA: '流感疫苗(每年10~2月接種)',
      MMR: '麻疹腮腺炎德國麻疹混合疫苗 (MMR)',
    },
    type: {
      0: 'UNKNOWN',
      1: 'TDAP',
      2: 'INFLUENZA',
      3: 'MMR',
    },
    typeToNumber: {
      UNKNOWN: 0,
      TDAP: 1,
      INFLUENZA: 2,
      MMR: 3,
    },
  },
  vaccine: {
    activation: ['BCG', 'VARICELLA', 'MMR', 'JE'],
    event: {
      UNKNOWN: 0,
      IVIG: 1,
      BT: 2,
      HDIVIG: 3,
      0: 'UNKNOWN',
      1: 'IVIG',
      2: 'BT',
      3: 'HDIVIG',
    },
    eventToString: {
      UNKNOWN: '',
      IVIG: '3個月內，接受過一般肌肉注射免疫球蛋白治療或HBIG',
      BT: '6個月內，輸過血或接受靜脈注射血液製品',
      HDIVIG: '11個月內，靜脈注射高劑量(≧1g/kg)免疫球蛋白治療',
    },
    eventToMonth: {
      UNKNOWN: 0,
      IVIG: 3,
      BT: 6,
      HDIVIG: 11,
    },
    category: {
      CATEGORY_TYPE_UNKNOWN: 'UNKNOWN',
      HOURS_24: '出生滿24個小時內',
      MONTH_1: '出生滿1個月',
      MONTH_2: '出生滿2個月',
      MONTH_4: '出生滿4個月',
      MONTH_5: '出生滿5個月',
      MONTH_6: '出生滿6個月',
      MONTH_6_12: '出生滿6~12個月',
      MONTH_12: '出生滿12個月',
      MONTH_12_15: '出生滿12~15個月',
      MONTH_12_24: '出生滿12~24個月',
      MONTH_15: '出生滿15個月',
      MONTH_16: '出生滿16個月',
      MONTH_18_21: '出生滿18~21個月',
      MONTH_24_36: '出生滿24~36個月',
      MONTH_27: '出生滿27個月',
      MONTH_28: '出生滿28個月',
      MONTH_36_48: '出生滿3~4歲',
      MONTH_48_60: '出生滿4~5歲',
      MONTH_60_72: '出生滿5~6歲',
      MONTH_60_TO_SCHOOL: '5歲至入⼩學前',
      OTHER: '其他',
      0: 'UNKNOWN',
      1: '出生滿24個小時內',
      2: '出生滿1個月',
      3: '出生滿2個月',
      4: '出生滿4個月',
      5: '出生滿5個月',
      6: '出生滿6個月',
      7: '出生滿6~12個月',
      8: '出生滿12個月',
      9: '出生滿12~15個月',
      10: '出生滿12~24個月',
      11: '出生滿15個月',
      12: '出生滿16個月',
      13: '出生滿18~21個月',
      14: '出生滿24~36個月',
      15: '出生滿27個月',
      16: '出生滿28個月',
      17: '出生滿3~4歲',
      18: '出生滿4~5歲',
      19: '出生滿5~6歲',
      20: '5歲至入⼩學前',
      21: '其他',
    },
    categoryToNumber: {
      CATEGORY_TYPE_UNKNOWN: 0,
      HOURS_24: 1,
      MONTH_1: 2,
      MONTH_2: 3,
      MONTH_4: 4,
      MONTH_5: 5,
      MONTH_6: 6,
      MONTH_6_12: 7,
      MONTH_12: 8,
      MONTH_12_15: 9,
      MONTH_12_24: 10,
      MONTH_15: 11,
      MONTH_16: 12,
      MONTH_18_21: 13,
      MONTH_24_36: 14,
      MONTH_27: 15,
      MONTH_28: 16,
      MONTH_36_48: 17,
      MONTH_48_60: 18,
      MONTH_60_72: 19,
      MONTH_60_TO_SCHOOL: 20,
      OTHER: 21,
    },
    name: {
      HBIG: 'B型肝炎免疫血球蛋白一劑',
      HEPB_1: 'B型肝炎疫苗第一劑',
      HEPB_2: 'B型肝炎疫苗第二劑',
      DTAP_HIB_IPV_1: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗第一劑',
      PCV13_1: '13價結合型肺炎鏈球菌疫苗第一劑',
      ROTA2_1: '(自費)2劑型輪狀病毒第一劑',
      ROTA3_1: '(自費)3劑型輪狀病毒第一劑',
      DTAP_HIB_IPV_2: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗第二劑',
      PCV13_2: '13價結合型肺炎鏈球菌疫苗第二劑',
      ROTA2_2: '(自費)2劑型輪狀病毒第二劑',
      ROTA3_2: '(自費)3劑型輪狀病毒第二劑',
      BCG: '卡介苗一劑',
      HEPB_3: 'B型肝炎疫苗第三劑',
      DTAP_HIB_IPV_3: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗第三劑',
      ROTA3_3: '(自費)3劑型輪狀病毒第三劑',
      INFLUENZA_1: '流感疫苗第一劑',
      INFLUENZA_2: '流感疫苗第二劑',
      PCV13_3: '13價結合型肺炎鏈球菌疫苗第三劑',
      VARICELLA: '水痘疫苗一劑',
      MMR_1: '麻疹腮腺炎德國麻疹混合疫苗第一劑',
      HEPA_1: 'A型肝炎疫苗第一劑',
      JE_1: '日本腦炎疫苗(活性減毒)第一劑',
      JE_2: '日本腦炎疫苗(活性減毒)第二劑',
      HEPA_2: 'A型肝炎疫苗第二劑',
      INFLUENZA_3: '流感疫苗一劑',
      DTAP_HIB_IPV_4: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗第四劑',
      INFLUENZA_4: '流感疫苗一劑',
      INFLUENZA_5: '流感疫苗一劑',
      INFLUENZA_6: '流感疫苗一劑',
      MMR_2: '麻疹腮腺炎德國麻疹混合疫苗第二劑',
      DTAP_IPV: '白喉破傷風非細胞性百日咳及不活化小兒麻痺混合疫苗一劑',
      INFLUENZA_7: '流感疫苗一劑',
      INFLUENZA_8: '流感疫苗一劑',
      JE_NON_ACTIVATED_1: '日本腦炎疫苗(不活化疫苗)第一劑',
      JE_NON_ACTIVATED_2: '日本腦炎疫苗(不活化疫苗)第二劑',
      JE_NON_ACTIVATED_3: '日本腦炎疫苗(不活化疫苗)第三劑',
      JE_NON_ACTIVATED_4: '日本腦炎疫苗(不活化疫苗)第四劑',
      DTAP_IPV_HEPB_HIB: '六合一疫苗(以取代應接種之第3劑B型肝炎疫苗及五合一疫苗)一劑',
    },
    status: {
      STATUS_UNKNOWN: 'STATUS_UNKNOWN',
      COMPLETED: 'COMPLETED',
      SCHEDULED: 'SCHEDULED',
      DISALLOWED: 'DISALLOWED',
      未接種: 'STATUS_UNKNOWN',
      已接種: 'COMPLETED',
      已預約: 'SCHEDULED',
      不用接種: 'DISALLOWED',
      toString: {
        STATUS_UNKNOWN: '未接種',
        COMPLETED: '已接種',
        SCHEDULED: '已預約',
        DISALLOWED: '不用接種', // only for HBIG vaccine
      },
    },
    dose: {
      1: '第一劑',
      2: '第二劑',
      3: '第三劑',
      4: '第四劑',
      5: '第五劑',
      6: '第六劑',
      7: '第七劑',
      8: '第八劑',
    },
    type: {
      0: 'UNKNOWN',
      1: 'HBIG',
      2: 'HEPB_1',
      3: 'HEPB_2',
      4: 'PCV13_1',
      5: 'DTAP_HIB_IPV_1',
      6: 'ROTA2_1',
      7: 'ROTA3_1',
      8: 'PCV13_2',
      9: 'DTAP_HIB_IPV_2',
      10: 'ROTA2_2',
      11: 'ROTA3_2',
      12: 'BCG',
      13: 'HEPB_3',
      14: 'DTAP_HIB_IPV_3',
      15: 'DTAP_IPV_HEPB_HIB',
      16: 'ROTA3_3',
      17: 'INFLUENZA_1',
      18: 'INFLUENZA_2',
      19: 'MMR_1',
      20: 'VARICELLA',
      21: 'PCV13_3',
      22: 'HEPA_1',
      23: 'INFLUENZA_3',
      24: 'INFLUENZA_4',
      25: 'JE_1',
      26: 'JE_NON_ACTIVATED_1',
      27: 'JE_NON_ACTIVATED_2',
      28: 'DTAP_HIB_IPV_4',
      29: 'HEPA_2',
      30: 'INFLUENZA_5',
      31: 'JE_2',
      32: 'JE_NON_ACTIVATED_3',
      33: 'INFLUENZA_6',
      34: 'INFLUENZA_7',
      35: 'INFLUENZA_8',
      36: 'MMR_2',
      37: 'DTAP_IPV',
      38: 'JE_NON_ACTIVATED_4',
    },
    typeToNumber: {
      UNKNOWN: 0,
      HBIG: 1,
      HEPB_1: 2,
      HEPB_2: 3,
      PCV13_1: 4,
      DTAP_HIB_IPV_1: 5,
      ROTA2_1: 6,
      ROTA3_1: 7,
      PCV13_2: 8,
      DTAP_HIB_IPV_2: 9,
      ROTA2_2: 10,
      ROTA3_2: 11,
      BCG: 12,
      HEPB_3: 13,
      DTAP_HIB_IPV_3: 14,
      DTAP_IPV_HEPB_HIB: 15,
      ROTA3_3: 16,
      INFLUENZA_1: 17,
      INFLUENZA_2: 18,
      MMR_1: 19,
      VARICELLA: 20,
      PCV13_3: 21,
      HEPA_1: 22,
      INFLUENZA_3: 23,
      INFLUENZA_4: 24,
      JE_1: 25,
      JE_NON_ACTIVATED_1: 26,
      JE_NON_ACTIVATED_2: 27,
      DTAP_HIB_IPV_4: 28,
      HEPA_2: 29,
      INFLUENZA_5: 30,
      JE_2: 31,
      JE_NON_ACTIVATED_3: 32,
      INFLUENZA_6: 33,
      INFLUENZA_7: 34,
      INFLUENZA_8: 35,
      MMR_2: 36,
      DTAP_IPV: 37,
      JE_NON_ACTIVATED_4: 38,
    },
  },
  // reference of grouping: https://www.cdc.gov.tw/CdcOrganization/Index/cBX61rWwT5TKpS7BbMzKag
  healthDepartmentNumbers: [
    {
      台北市衛生局: 'tel:+886223754341',
      新北市衛生局: 'tel:+886222588923',
      基隆市衛生局: 'tel:+886224276154',
      宜蘭縣衛生局: 'tel:+88639357011',
      連江縣衛生局: 'tel:+88683622095,8850',
      金門縣衛生局: 'tel:+88682330751',
    },
    {
      桃園市衛生局: 'tel:+886800033355',
      新竹市衛生局: 'tel:+88635355191,212',
      新竹縣衛生局: 'tel:+88635518160,206',
      苗栗縣衛生局: 'tel:+88637558100',
    },
    {
      台中市衛生局: 'tel:+886425265394,3502',
      彰化縣衛生局: 'tel:+88647115141,5104',
      南投縣衛生局: 'tel:+886492220904',
    },
    {
      雲林縣衛生局: 'tel:+88655345811',
      嘉義市衛生局: 'tel:+88652341150',
      嘉義縣衛生局: 'tel:+88653620607',
      台南市衛生局: 'tel:+88662880180',
    },
    {
      高雄市衛生局: 'tel:+88677230250',
      屏東縣衛生局: 'tel:+88687370175',
      澎湖縣衛生局: 'tel:+88669272162,211',
    },
    {
      花蓮縣衛生局: 'tel:+88638227141,526',
      台東縣衛生局: 'tel:+88689331171,217',
    },
  ],
  stdType: {
    AIDS_ANONYMOUS_TEST: 'aids-anonymous-test',
    AIDS_SELF_TEST: 'aids-self-test',
    AIDS_TREATMENT: 'aids-treatment',
    CONDOM: 'condom',
    FRIENDLY: 'friendly',
    PEP: 'pep',
    PREP: 'prep',
  },
  diseaseNameSpecialCaseMapping: {
    類流感: '流感',
    流感併發重症: '流感',
    腸病毒感染併發重症: '腸病毒',
  },
  seasonalVaccines: {
    GROUPS: [
      {
        value: 'elderly-medical',
        label: '65歲以上或醫護人員',
        notice: '若您或您的家人是65歲以上或是不分年齡但是有醫護人員身份',
      },
      {
        value: 'middle',
        label: '50-64歲',
        notice: '若您或您的家人是50-64歲',
      },
      {
        value: 'youth',
        label: '18-49歲',
        notice: '若您或您的家人是18-49歲',
      },
      {
        value: 'underage',
        label: '6個月以上-18歲',
        notice: '若您或您的家人是6個月以上-18歲',
      },
    ],
  },
};
